import "./offline-banner.scss";

import * as React from "react";

export default function OfflineBanner() {
	return <div className="offline-banner">Du er offline og kan ikke kjøpe pass</div>;
}
